<ion-button expand="block" [color]="color" (click)="getKeyValues()" [disabled]="to.disabled">{{label}}</ion-button>
<ion-item lines="none">
  <div #flowDiv class="overflow" (scroll)="hideScrollArrow()">
    <table #itemTable class="fullsize valuelist"></table>
  </div>
  <ion-icon class="overflow-indicator aniHoverX" name="chevron-forward-sharp" *ngIf="showOverflowArrow"></ion-icon>
</ion-item>